module.exports = __webpack_public_path__ + "static/images/cookie.bcab3173a614ca29fe7d1208e31eacbc.svg";